import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5ecccfc4")

_pushScopeId("data-v-5ecccfc4")
const _hoisted_1 = { id: "header-container" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "left-side" }
const _hoisted_5 = { id: "logo" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "mmenu-trigger" }, [
  /*#__PURE__*/_createVNode("button", {
    class: "hamburger hamburger--collapse",
    type: "button"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "hamburger-box" }, [
      /*#__PURE__*/_createVNode("span", { class: "hamburger-inner" })
    ])
  ])
], -1)
const _hoisted_8 = {
  id: "navigation",
  class: "style-1"
}
const _hoisted_9 = { id: "responsive" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Home 6 (Map)")
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<li data-v-5ecccfc4><a href=\"#\" data-v-5ecccfc4>Listings</a><ul data-v-5ecccfc4><li data-v-5ecccfc4><a href=\"#\" data-v-5ecccfc4>List Layout</a><ul data-v-5ecccfc4><li data-v-5ecccfc4><a href=\"listings-list-with-sidebar.html\" data-v-5ecccfc4>With Sidebar</a></li><li data-v-5ecccfc4><a href=\"listings-list-full-width.html\" data-v-5ecccfc4>Full Width</a></li><li data-v-5ecccfc4><a href=\"listings-list-full-width-with-map.html\" data-v-5ecccfc4>Full Width + Map</a></li></ul></li><li data-v-5ecccfc4><a href=\"#\" data-v-5ecccfc4>Grid Layout</a><ul data-v-5ecccfc4><li data-v-5ecccfc4><a href=\"listings-grid-with-sidebar-1.html\" data-v-5ecccfc4>With Sidebar 1</a></li><li data-v-5ecccfc4><a href=\"listings-grid-with-sidebar-2.html\" data-v-5ecccfc4>With Sidebar 2</a></li><li data-v-5ecccfc4><a href=\"listings-grid-full-width.html\" data-v-5ecccfc4>Full Width</a></li><li data-v-5ecccfc4><a href=\"listings-grid-full-width-with-map.html\" data-v-5ecccfc4>Full Width + Map</a></li></ul></li></ul></li>", 1)
const _hoisted_13 = /*#__PURE__*/_createVNode("a", { href: "#" }, "User Panel", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("My bookings")
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<li data-v-5ecccfc4><a href=\"#\" data-v-5ecccfc4>Pages</a><div class=\"mega-menu mobile-styles three-columns\" data-v-5ecccfc4><div class=\"mega-menu-section\" data-v-5ecccfc4><ul data-v-5ecccfc4><li class=\"mega-menu-headline\" data-v-5ecccfc4>Pages #1</li><li data-v-5ecccfc4><a href=\"pages-user-profile.html\" data-v-5ecccfc4><i class=\"sl sl-icon-user\" data-v-5ecccfc4></i> User Profile</a></li><li data-v-5ecccfc4><a href=\"pages-booking.html\" data-v-5ecccfc4><i class=\"sl sl-icon-check\" data-v-5ecccfc4></i> Booking Page</a></li><li data-v-5ecccfc4><a href=\"pages-add-listing.html\" data-v-5ecccfc4><i class=\"sl sl-icon-plus\" data-v-5ecccfc4></i> Add Listing</a></li><li data-v-5ecccfc4><a href=\"pages-blog.html\" data-v-5ecccfc4><i class=\"sl sl-icon-docs\" data-v-5ecccfc4></i> Blog</a></li></ul></div><div class=\"mega-menu-section\" data-v-5ecccfc4><ul data-v-5ecccfc4><li class=\"mega-menu-headline\" data-v-5ecccfc4>Pages #2</li><li data-v-5ecccfc4><a href=\"pages-contact.html\" data-v-5ecccfc4><i class=\"sl sl-icon-envelope-open\" data-v-5ecccfc4></i> Contact</a></li><li data-v-5ecccfc4><a href=\"pages-coming-soon.html\" data-v-5ecccfc4><i class=\"sl sl-icon-hourglass\" data-v-5ecccfc4></i> Coming Soon</a></li><li data-v-5ecccfc4><a href=\"pages-404.html\" data-v-5ecccfc4><i class=\"sl sl-icon-close\" data-v-5ecccfc4></i> 404 Page</a></li><li data-v-5ecccfc4><a href=\"pages-masonry-filtering.html\" data-v-5ecccfc4><i class=\"sl sl-icon-equalizer\" data-v-5ecccfc4></i> Masonry Filtering</a></li></ul></div><div class=\"mega-menu-section\" data-v-5ecccfc4><ul data-v-5ecccfc4><li class=\"mega-menu-headline\" data-v-5ecccfc4>Other</li><li data-v-5ecccfc4><a href=\"pages-elements.html\" data-v-5ecccfc4><i class=\"sl sl-icon-settings\" data-v-5ecccfc4></i> Elements</a></li><li data-v-5ecccfc4><a href=\"pages-pricing-tables.html\" data-v-5ecccfc4><i class=\"sl sl-icon-tag\" data-v-5ecccfc4></i> Pricing Tables</a></li><li data-v-5ecccfc4><a href=\"pages-typography.html\" data-v-5ecccfc4><i class=\"sl sl-icon-pencil\" data-v-5ecccfc4></i> Typography</a></li><li data-v-5ecccfc4><a href=\"pages-icons.html\" data-v-5ecccfc4><i class=\"sl sl-icon-diamond\" data-v-5ecccfc4></i> Icons</a></li></ul></div></div></li>", 1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_17 = { class: "right-side" }
const _hoisted_18 = { class: "header-widget" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-login" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Sign In")
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-user" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Profile")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Add Listing")
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-plus" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _hoisted_7,
          _createVNode("nav", _hoisted_8, [
            _createVNode("ul", _hoisted_9, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withId(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withId(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_12,
              _createVNode("li", null, [
                _hoisted_13,
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/dashboard/bookings" }, {
                      default: _withId(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_15
            ])
          ]),
          _hoisted_16
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            (!_ctx.user)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/login",
                  class: "sign-in"
                }, {
                  default: _withId(() => [
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/profile",
                  class: "sign-in"
                }, {
                  default: _withId(() => [
                    _hoisted_21,
                    _hoisted_22
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user)
              ? (_openBlock(), _createBlock("a", {
                  key: 2,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
                  class: "sign-in"
                }, "Logout"))
              : _createCommentVNode("", true),
            (_ctx.user)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: "/add-place",
                  class: "button border with-icon"
                }, {
                  default: _withId(() => [
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
})